import React, { Component } from 'react';
import { Table } from 'antd';
import { connect } from 'react-redux';
import moment from 'moment';
import { Link } from 'react-router';

import { getIncCustomList } from '@store/modules/incubator/incu_custom_list';

class TabOut extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentWillMount() {}

  componentDidMount() {
    this.condition = this.props.condition;
    if (this.props.condition.incubatorUuid) {
      this.current = this.props.condition.incubatingCustomerCurrent || 1;
      this.pageSize = this.props.condition.incubatingCustomerPageSize || 10;
      this.getIncCustomList();
    }
  }

  componentWillReceiveProps(nextProps) {
    if (
      Object.keys(nextProps.condition).some(
        item => nextProps.condition[item] !== this.props.condition[item],
      )
    ) {
      this.current = 1;
      this.condition = nextProps.condition;
      this.getIncCustomList();
    }
  }

  getIncCustomList = () => {
    const pageSize = this.pageSize || 10;
    this.current = this.current || 1;
    this.props.dispatch(
      getIncCustomList({
        limit: pageSize,
        current: this.current,
        start: this.current,
        tab: 'incubatingCustomer',
        ...this.condition,
      }),
    );
  };

  onTableChange = pagination => {
    this.current = pagination.current;
    this.pageSize = pagination.pageSize;
    this.getIncCustomList();
  };

  getTags = tags => {
    return tags.reduce((prev, curr) => `${prev + curr.name}、`, '');
  };

  onSearch = params => {
    this.condition = params;
    this.current = 1;
    this.getIncCustomList();
  };

  columns = () => {
    const {
      condition: { incubatorUuid },
    } = this.props;
    return [
      {
        title: '公司名称',
        dataIndex: 'customName',
        key: 'customName',
        render: (text, record) => (
          <Link to={`/incubator/${incubatorUuid}/custom/detail/${record.customUuid}`}>{text}</Link>
        ),
      },
      {
        title: '联系人',
        dataIndex: 'contactName',
        key: 'contactName',
      },
      {
        title: '联系方式',
        dataIndex: 'contactTel',
        key: 'contactTel',
      },
      {
        title: '标签',
        dataIndex: 'tags',
        key: 'tags',
        render: (text, record) => <span>{this.getTags(record.tags)}</span>,
      },
      {
        title: '是否获得融资',
        dataIndex: 'isFinancing',
        key: 'isFinancing',
        render: text => {
          const string = text === 1 ? '是' : '否';
          return <span>{text ? string : ''}</span>;
        },
      },
      {
        title: '开始入驻时间',
        dataIndex: 'beginDate',
        key: 'beginDate',
        render: (text, record) => (
          <span>{text ? moment.unix(text / 1000).format('YYYY-MM-DD') : ''}</span>
        ),
      },
      {
        title: '合同到期时间',
        dataIndex: 'endDate',
        key: 'endDate',
        render: (text, record) => (
          <span>{text ? moment.unix(text / 1000).format('YYYY-MM-DD') : ''}</span>
        ),
      },
      {
        title: '迁出理由',
        dataIndex: 'moveOutReason',
        key: 'moveOutReason',
      },
      {
        title: '迁出时间',
        dataIndex: 'moveOutDate',
        key: 'moveOutDate',
        render: (text, record) => {
          let diff = 0;
          if (text) {
            diff = Math.floor((text - record.endDate) / 86400000);
          }

          return (
            <div>
              {text ? moment.unix(text / 1000).format('YYYY-MM-DD') : ''}
              <p style={{ marginBottom: '0' }}>{diff < 0 ? `（提前${Math.abs(diff)}天）` : ''}</p>
              <p style={{ color: 'red', marginBottom: '0' }}>
                {diff > 0 ? `（逾期${Math.abs(diff)}天）` : ''}
              </p>
            </div>
          );
        },
      },
    ];
  };

  render() {
    const {
      dataSource: { list, pagination },
      loading,
    } = this.props;
    return (
      <div>
        <Table
          dataSource={list}
          columns={this.columns()}
          pagination={pagination}
          onChange={this.onTableChange}
          loading={loading}
          rowKey="uuid"
        />
      </div>
    );
  }
}

export default connect(state => ({
  incuInfo: state.incubator_base,
  dataSource: state.incu_custom_list.incubatingCustomerDataSource,
  loading: state.incu_custom_list.incubatingCustomerLoading,
}))(TabOut);



// WEBPACK FOOTER //
// ./src/components/incubator/custom/TableOut.js